import { render, staticRenderFns } from "./team.vue?vue&type=template&id=a9bc1e52&scoped=true&"
import script from "./team.vue?vue&type=script&lang=js&"
export * from "./team.vue?vue&type=script&lang=js&"
import style0 from "./team.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./team.vue?vue&type=style&index=1&id=a9bc1e52&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9bc1e52",
  null
  
)

export default component.exports